import * as Yup from 'yup';

const newRegistroOfx = {
    contaBanco: null,
    arquivoOfx: null,
    saldoFinal: ''
};

const validationOfx = Yup.object().shape({
    contaBanco: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    arquivoOfx: Yup.mixed()
        .required('É obrigatório selecionar um arquivo OFX'),
    saldoFinal: Yup.number()
        .typeError('Este campo é obrigatório')
        .required("Este campo é obrigatório")
        .test('decimal', 'Valor deve ser um número válido', value => {
            return /^\d+(\.\d{1,2})?$/.test(value);
        })
});

export const conciliacaoBancariaOfx = {
    newRegistroOfx,
    validationOfx
}